/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import TextInputField from "../../../components/_utils/CommonInputFields/TextInputField";
import PrimaryButton from "../../../components/_utils/CommonButtons/PrimaryButton";
import { useDispatch } from "react-redux";
import {
  getSpecificPrivateTransactions,
  otpResend,
  otpSend,
  otpValidation,
  resetOtpError,
} from "../../../redux/features/privatetransactions/privatetransactions";
import { useNavigate } from "react-router-dom";
import CommonToast from "../../_utils/CommonToast";
import { toast } from "react-toastify";
import globalText from "../../../utils/globalText";
import { GlobalConfiguration } from "../../../utils/configurationProvider";
import ICONS from "../../../assets/Icons";

const AuthenticationPopup = ({
  setOpenAuthenticationPopup,
  otpValidationLoading,
  otpValidationError,
  delay,
  id,
  ref_id,
  openAuthenticationPopup,
  setViewInternalTxnDetails,
  type,
  setPrivateTxnData,
  currentOtpCount,
  setSelectedOtpCount,
  isPopup,
}) => {
  const [timeLeft, setTimeLeft] = useState(GlobalConfiguration.otpCount);
  const dispatch = useDispatch();
  const [isDisabled, setIsDisabled] = useState(false);
  const [OTP, setOTP] = useState("");
  const [openRequestOTP, setOpenRequestOTP] = useState(true);
  const [openVerifyOTP, setVerifyOTP] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [currentState, setCurrentState] = useState(openAuthenticationPopup);
  const [requestOtp, setRequestOtp] = useState(false);

  const navigate = useNavigate();

  const handleKeyPress = (e) => {
    if (!otpValidationError && OTP?.length >= GlobalConfiguration.otpLength) {
      if (
        e.key === "Enter" &&
        !otpValidationError &&
        OTP?.length >= GlobalConfiguration.otpLength
      ) {
        handleVerify();
      }
    }
  };

  useEffect(() => {
    document.addEventListener("keypress", handleKeyPress);

    return () => {
      document.removeEventListener("keypress", handleKeyPress);
    };
  }, [OTP, otpValidationError]);

  const handleCancel = async () => {
    setCurrentState(false);
    await delay(globalText.ANIMATION_LENGTH);
    dispatch(resetOtpError());
    setOpenAuthenticationPopup(false);
    setVerifyOTP(false);
    setOpenRequestOTP(true);
  };

  useEffect(() => {
    if (OTP?.length < GlobalConfiguration.otpLength) {
      dispatch(resetOtpError());
    }
  }, [OTP]);
  const handleVerify = async () => {
    if (!otpValidationError && OTP?.length >= GlobalConfiguration.otpLength) {
      try {
        CommonToast({
          text: "Authenticating transaction",
          icon: "https://q2pay.in/new_assets/gifs/inputloader_white.gif",
          variant: "var(--processing)",
          buttonNeeded: false,
          btnProps: {
            enabledBgColor: "var(--primary-bg)",
            enabledTextColor: "var(--text-primary)",
            btnText: "",
            handleFunction: () => {},
            icon: "",
            btnType: "button",
            isDisabled: false,
            hoverOption: "white",
          },
        });
        setIsLoading(true);
        await delay(globalText?.ANIMATION_LENGTH_LONG);

        const data = await dispatch(
          otpValidation({ id: id, otp: OTP }),
        ).unwrap();

        if (data?.status) {
          navigate(
            `/private_transaction_dashboard/private_transaction_view_all/private_transaction_detail_page/success/${ref_id}`,
          );
        }
      } catch (error) {
        if (
          error?.response?.data?.errors?.base?.[0] ===
          "OTP Incorrect! OTP Attempts Exhausted! Blocking current Transaction."
        ) {
          if (type !== "detail_page") {
            setPrivateTxnData((prev) => ({
              ...prev,
              transaction_requests: prev.transaction_requests.map((item) =>
                item.request_reference_id === ref_id
                  ? {
                      ...item,
                      request_status: "blocked",
                    }
                  : item,
              ),
            }));
          } else {
            if (isPopup) {
              setPrivateTxnData((prev) => ({
                ...prev,
                transaction_requests: prev.transaction_requests.map((item) =>
                  item.request_reference_id === ref_id
                    ? {
                        ...item,
                        request_status: "blocked",
                      }
                    : item,
                ),
              }));
            }
            await dispatch(
              getSpecificPrivateTransactions({ id: ref_id }),
            ).unwrap();
          }
          handleCancel();
        } else if (
          error?.response?.data?.errors?.base?.[0] === "OTP Incorrect!"
        ) {
          setRequestOtp(true);

          if (type === "detail_page") {
            setViewInternalTxnDetails((prev) => [
              {
                ...prev[0],
                otp_attempts_count: prev[0].otp_attempts_count + 1,
              },
            ]);
          } else {
            setPrivateTxnData((prev) => ({
              ...prev,
              transaction_requests: prev.transaction_requests.map((item) =>
                item.request_reference_id === ref_id
                  ? {
                      ...item,
                      otp_attempts_count: item.otp_attempts_count + 1,
                    }
                  : item,
              ),
            }));
            setSelectedOtpCount((prev) => prev + 1);
          }
        }
        toast.dismiss();
        CommonToast({
          text:
            error?.response?.data?.errors?.base[
              GlobalConfiguration.lengthCheckZero
            ] || "Authentication failed.",
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
        return error;
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleRequestOTP = () => {
    setOpenRequestOTP(false);
    setVerifyOTP(true);

    dispatch(otpSend({ id: id }));

    setTimeLeft(GlobalConfiguration.otpCount);
    setIsDisabled(true);
  };

  const handleAgainRequestOTP = () => {
    setRequestOtp(false);
    dispatch(otpSend({ id: id }));
    setOTP("");
    dispatch(resetOtpError());
    toast.dismiss();
    CommonToast({
      text: "OTP requested",
      icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
      variant: "var(--success)",
    });
    setTimeLeft(GlobalConfiguration.otpCount);
    setIsDisabled(true);
  };

  useEffect(() => {
    let timer;

    if (isDisabled && timeLeft > GlobalConfiguration?.lengthCheckZero) {
      timer = setInterval(() => {
        setTimeLeft((prev) => prev - GlobalConfiguration?.lengthCheckOne);
      }, globalText?.ANIMATION_LENGTH_LONG);
    }

    if (timeLeft === GlobalConfiguration?.lengthCheckZero) {
      setIsDisabled(false);
    }

    return () => clearInterval(timer);
  }, [timeLeft, isDisabled]);

  const formatTime = (seconds) => {
    const m = Math.floor(seconds / GlobalConfiguration.otpCount);
    const s = seconds % GlobalConfiguration.otpCount;
    return `${m}:${s.toString().padStart(GlobalConfiguration?.lengthCheckTwo, "0")}`;
  };

  const handleResend = () => {
    if (!isDisabled) {
      dispatch(otpResend({ id: id }));
      setTimeLeft(GlobalConfiguration.otpCount);
      setIsDisabled(true);
    }
  };
  const handleOtpInput = (e) => {
    const value = e.target.value;

    const digitsOnly = value
      .replace(/\D/g, "")
      .slice(
        GlobalConfiguration?.lengthCheckZero,
        GlobalConfiguration.otpLength,
      );

    setOTP(digitsOnly);
  };

  return (
    <div>
      <div className="fixed top-top-base left-left-base w-full-width h-full-height z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
        {openVerifyOTP && (
          <div className="mainPopup">
            <div
              className={`flex flex-col px-padding-md bg-primary-bg rounded-border-radius-md opacity-base-opacity mx-margin-xs w-[var(--pop-up-width)] min-h-[var(--bene-txn-dropdown-height-mobile)] animate-none ${currentState ? "Qmd:animate-slideInFromRight" : "Qmd:animate-slideInFromLeft"}`}
            >
              <div className="flex flex-col">
                <h2 className="text-left text-font-md mt-margin-md font-semibold tracking-letter-space text-text-primary opacity-base-opacity ">
                  Authenticate transaction
                </h2>
                <p className="text-left text-font-xs font-normal text-text-secondary opacity-base-opacity whitespace-nowrap  mt-margin-xs">
                  Authentication required to create transaction.
                </p>
              </div>

              <div className="otp_input_field mt-margin-md flex relative mr-margin-md">
                <TextInputField
                  bgColor="var(--primary-bg)"
                  fgColor={
                    OTP?.length
                      ? "var(--text-primary)"
                      : "var(--text-secondary)"
                  }
                  placeholder="Enter OTP"
                  isFullWidth={true}
                  onInput={(e) => handleOtpInput(e)}
                  value={OTP}
                  variant={otpValidationError && "error"}
                  isDisabled={requestOtp ? true : false}
                />
              </div>

              <div className="w-full   font-sans text-font-sm font-normal flex  flex-col">
                {otpValidationError && (
                  <p className="text-negative-act text-font-xs mt-margin-sm">
                    Invalid OTP entered.
                  </p>
                )}
                {requestOtp ? (
                  <p className="text-text-secondary text-font-xs my-margin-md">
                    Note : Incorrect OTP entered. Request a new OTP to proceed.
                  </p>
                ) : (
                  <div className="flex mb-margin-md mt-margin-sm gap-gap-xs">
                    <button
                      onClick={handleResend}
                      disabled={isDisabled}
                      className={`transition-colors duration-300 underline text-text-primary font-semibold text-font-xs ${
                        isDisabled
                          ? "opacity-light-opacity cursor-not-allowed"
                          : "opacity-base-opacity"
                      }`}
                    >
                      Resend OTP
                    </button>
                    <p className="text-text-secondary text-font-xs">
                      {isDisabled ? `in ${formatTime(timeLeft)} min` : ""}
                    </p>
                  </div>
                )}
              </div>
              {currentOtpCount >= 2 && (
                <div className="w-full bg-emphasis font-normal py-padding-sm mb-margin-md rounded-border-radius-md flex justify-start items-center">
                  <img
                    src={ICONS.ERROR_WHITE_CIRCLE}
                    alt=""
                    className="mx-margin-sm h-[20px] w-[20px]"
                  />
                  <p className="text-text-primary text-font-xs">
                    Final attempt left, Next incorrect OTP will permanently
                    block this transaction.
                  </p>
                </div>
              )}

              <div className="BeneTxn_benefbtnconfandCan flex items-center justify-end gap-gap-sm  mb-margin-md ml-margin-base">
                <PrimaryButton
                  btnText="Cancel"
                  btnType="button"
                  handleFunction={handleCancel}
                  isDisabled={false}
                  enabledTextColor="var(--text-primary)"
                  enabledBgColor="var(--primary-bg)"
                  outLineColor="var(--text-primary)"
                  hoverOption="white"
                  fullWidthRequired={false}
                />
                {requestOtp ? (
                  <PrimaryButton
                    btnText="Request new OTP"
                    btnType="button"
                    handleFunction={handleAgainRequestOTP}
                    // isDisabled={
                    //   OTP?.length < GlobalConfiguration.otpLength ||
                    //   OTP === undefined ||
                    //   otpValidationError
                    // }
                    enabledTextColor="var(--text-primary)"
                    disabledTextColor="var(--text-primary)"
                    enabledBgColor="var(--positive-act)"
                    disabledBgColor="var(--text-disabled)"
                    hoverOption="black"
                    isLoaderNeeded={true}
                    fullWidthRequired={false}
                    // isLoading={otpValidationLoading || isLoading}
                  />
                ) : (
                  <PrimaryButton
                    btnText="Verify"
                    btnType="button"
                    handleFunction={handleVerify}
                    isDisabled={
                      OTP?.length < GlobalConfiguration.otpLength ||
                      OTP === undefined ||
                      otpValidationError
                    }
                    enabledTextColor="var(--text-primary)"
                    disabledTextColor="var(--text-primary)"
                    enabledBgColor="var(--positive-act)"
                    disabledBgColor="var(--text-disabled)"
                    hoverOption="black"
                    isLoaderNeeded={true}
                    inActiveVariantNeeded
                    fullWidthRequired={false}
                    isLoading={otpValidationLoading || isLoading}
                  />
                )}
              </div>
            </div>
          </div>
        )}
        {openRequestOTP && (
          <div className="mainPopup">
            <div
              className={`flex flex-col bg-primary-bg rounded-border-radius-md opacity-base-opacity mx-margin-xs w-[var(--pop-up-width)] animate-none ${currentState ? "Qmd:animate-slideInFromRight" : "Qmd:animate-slideInFromLeft"} `}
            >
              <div className="flex flex-col">
                <h2 className="text-left text-font-md mt-margin-md font-semibold text-text-primary opacity-base-opacity ml-margin-md">
                  Authenticate transaction
                </h2>
                <p className="text-left text-font-xs font-normal text-text-secondary opacity-base-opacity  ml-margin-md mt-margin-xs">
                  Authentication required to create the newly validated
                  transaction.
                </p>
              </div>

              <div className="otp_input_field flex relative mr-margin-md mb-margin-md">
                <h2 className="text-left text-font-xs mt-margin-md font-normal text-text-primary opacity-base-opacity ml-margin-md">
                  An OTP will be sent to the contact number associated with the
                  source bank account.
                </h2>
              </div>

              <div className="BeneTxn_benefbtnconfandCan flex items-center justify-end gap-gap-sm mr-margin-md mb-margin-md ml-margin-base">
                <PrimaryButton
                  btnText="Cancel"
                  btnType="button"
                  handleFunction={handleCancel}
                  isDisabled={false}
                  enabledTextColor="var(--text-primary)"
                  enabledBgColor="var(--primary-bg)"
                  outLineColor="var(--text-primary)"
                  hoverOption="white"
                  fullWidthRequired={false}
                />
                <PrimaryButton
                  btnText="Request OTP"
                  btnType="button"
                  handleFunction={handleRequestOTP}
                  enabledTextColor="var(--primary-bg)"
                  disabledTextColor="var(--text-primary)"
                  enabledBgColor="var(--text-primary)"
                  hoverOption="black"
                  isLoaderNeeded={true}
                  fullWidthRequired={false}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AuthenticationPopup;
